<header>
  <div [id]="identifierService.labelId('confirmationDialog', 'deviceChange')" class="pageTitle" data-tx-key="label.gb.device_change">{{ 'label.gb.device_change' | translate }}</div>
</header>
<br />
<span [id]="identifierService.labelId('confirmation-dialog', 'reasonForChange')" data-tx-key="msg.pa057.prompt"
    [innerHTML]="
        getReasonForChange('msg.pa057.prompt', firstName, lastName, patientId)
    "
></span>
<br />
<br />
<mat-radio-group
  class="radio-group align-fields row device-change-out-popup"
  [(ngModel)]="deviceChange"
  >
  <mat-radio-button [id]="identifierService.checkboxId('confirmation-dialog', 'changeDevice')" class="col-sm-12" color="primary" value="ChangeDevice" data-tx-key="label.gb.change_out"
    >{{ 'label.gb.change_out' | translate }}
    <!-- <p
    [innerHTML]="translate('msg.gb.change_out_instr')"
  ></p>  -->
  @if (deviceInfoText) {
    <br/><br/>
    <p [id]="identifierService.labelId('confirmation-dialog', 'deviceInfoText')" [innerHTML]="deviceInfoText"></p>
  }
</mat-radio-button>&nbsp;

<mat-radio-button [id]="identifierService.checkboxId('confirmation-dialog', 'correctDevice')" class="col-sm-12" color="primary" value="CorrectDevice" [disabled]="disableRadioBtn"
  data-tx-key="label.gb.data_correction"
  >{{ 'label.gb.data_correction' | translate }}
  <p [id]="identifierService.labelId('confirmation-dialog', 'dataCorrectionInstr')"
    [innerHTML]="translate(dataCorrectionKey)"
  ></p> </mat-radio-button
  >&nbsp;
</mat-radio-group>

<div class="row">
  <div class="col-sm-offset-8 col-sm-4 closeIcon" >
    <button
      mat-dialog-close
      mat-raised-button
      class="btn-styl"
      color="accent"
      (click)="cancel()"
            [id]="
                identifierService.dropdownId(
                    'address-contact-information',
                    'cancel'
                )
            "
      >
      {{ 'label.gb.button_cancel' | translate }}</button
      >&nbsp;&nbsp;
      <button
        mat-raised-button
        class="btn-styl"
        color="primary"
        (click)="continue()"
        [disabled]="!deviceChange"
            [id]="
                identifierService.dropdownId(
                    'address-contact-information',
                    'continue'
                )
            "
        data-tx-key="label.gb.continue"
        >
        {{ 'label.gb.continue' | translate }}</button
        >&nbsp;&nbsp;
      </div>
    </div>
